import { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/profile-pic.png";
import heroBg from "../assets/img/hero-bg.png";
import { ArrowRightCircle } from "react-bootstrap-icons";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

if (typeof window !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState("");
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [, setIndex] = useState(1);
  const containerRef = useRef(null);
  const heroContentRef = useRef(null);

  useGSAP(() => {
    if (heroContentRef.current) {
      gsap.to(heroContentRef.current, {
        scrollTrigger: {
          trigger: "body",
          start: "top top",
          end: () => `+=${window.innerHeight}`,
          scrub: 1.2,
        },
        y: () => -window.innerHeight * 0.25,
        opacity: 0,
        filter: "blur(16px)",
        ease: "power1.inOut",
      });
    }
  }, { scope: containerRef });

  const toRotate = [
    "Associate Software Engineer",
    "Full Stack Web Developer",
    "Frontend Developer",
    "Backend Developer",
  ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta);
    return () => clearInterval(ticker);
  });

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting
      ? fullText.substring(0, text.length - 1)
      : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta((prevDelta) => prevDelta / 2);
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex((prevIndex) => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === "") {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex((prevIndex) => prevIndex + 1);
    }
  };

  return (
    <section className="banner" id="home" ref={containerRef}>
      {/* Background elements */}
      <div className="banner-bg">
        <img src={heroBg} alt="Background" className="banner-bg-img" />
        <div className="grid-lines"></div>
        <div className="glow-spot glow-spot--cyan"></div>
        <div className="glow-spot glow-spot--violet"></div>
        <div className="glow-spot glow-spot--rose"></div>
      </div>

      <div ref={heroContentRef} style={{ width: "100%", zIndex: 1 }}>
        <Container>
          <Row className="align-items-center">
            <Col xs={12} md={6} xl={7}>
              <div className="status-badge">
                <span className="status-dot"></span>
                Available for opportunities
              </div>

              <h1>
                Hi, I'm{" "}
                <span className="gradient-text">Ushan</span>
                <br />
                <span className="gradient-text">Mihiranga</span>
              </h1>

              <div className="role-text">
                <span className="wrap">{text}</span>
              </div>

              <p className="banner-description">
                I craft modern web experiences with clean code and creative design.
                Passionate about building scalable applications that make a real
                impact. Always learning, always shipping.
              </p>

              <div className="hero-stats">
                <div className="hero-stat">
                  <div className="hero-stat-number">20+</div>
                  <div className="hero-stat-label">Projects</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">2+</div>
                  <div className="hero-stat-label">Years Exp</div>
                </div>
                <div className="hero-stat">
                  <div className="hero-stat-number">100%</div>
                  <div className="hero-stat-label">Dedication</div>
                </div>
              </div>

              <div className="hero-actions">
                <a href="#connect" className="btn-primary-glow">
                  <span>Let's Connect</span>
                  <ArrowRightCircle size={20} />
                </a>
                <a href="#projects" className="btn-outline-glass">
                  <span>View Projects</span>
                </a>
              </div>
            </Col>

            <Col xs={12} md={6} xl={5}>
              <div className="banner-image-wrapper">
                <div className="hero-image-container">
                  <div className="hero-image-ring"></div>
                  <div className="hero-image-glow"></div>
                  <img src={headerImg} alt="Ushan Mihiranga" className="hero-portrait" />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <div className="scroll-indicator-mouse"></div>
        <span className="scroll-indicator-text">Scroll</span>
      </div>
    </section>
  );
};
